import slugify from 'slugify';

const createSlug = (str: string) => slugify(str, { lower: true });

export default createSlug;
